export default __webpack_public_path__ + "static/media/LSP_Magazine.0ec9e270.png";